<div class="container">
    <div class="row">
        <div class="row-title">{{'dashboard.provider' | stringLiterals}} <span class="required-field">*</span></div>
        <div class="control">
            <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" [filterable]="false" [data]="providerList"
                [textField]="'name'" [valueField]="'id'" [value]="selectedProvider"
                (valueChange)="onProviderChange($event)"></kendo-dropdownlist>
        </div>
    </div>
    <div class="row">
        <div class="row-title">{{'dashboard.field' | stringLiterals}} <span class="required-field">*</span></div>
        <div class="control">
            <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" [filterable]="false" [data]="fieldList"
                [textField]="'name'" [valueField]="'name'" [value]="selectedField"
                (valueChange)="onFieldChange($event)"></kendo-dropdownlist>
        </div>
    </div>
    <div class="row">
        <div class="row-title">{{'dashboard.parameter_value' | stringLiterals}} <span class="required-field">*</span>
        </div>
        <div class="control">
            <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" [filterable]="false"
                [data]="parameterValueList" [textField]="'value'" [valueField]="'id'" [value]="selectedParameterValue"
                (valueChange)="onParameterValueChange($event)">
            </kendo-dropdownlist>
        </div>
    </div>
    <div *ngIf="!selectedField||!isDateType(selectedField&&selectedField.type)" class="row">
        <div class="row-title">{{'dashboard.data_type' | stringLiterals}}</div>
        <div class="control">
            <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" [filterable]="false" [data]="dataTypeList"
                [textField]="'value'" [valueField]="'id'" [value]="selectedDataType"
                (valueChange)="onDataTypeChange($event)"></kendo-dropdownlist>
        </div>
    </div>
    <div *ngIf="isDateType(selectedField&&selectedField.type)" class="row">
        <div class="row-title">{{'dashboard.display' | stringLiterals}}</div>
        <div class="control">
            <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" [filterable]="false" [data]="displayList"
                [textField]="'value'" [valueField]="'id'" [value]="selectedDisplay"
                (valueChange)="onDisplayChange($event)"></kendo-dropdownlist>
        </div>
    </div>
    <div *ngIf="selectedField&&selectedDataType&&isNumber">
        <div *ngIf="!isPercent&&!isRatio" class="row">
            <div class="row-title">{{'dashboard.scale' | stringLiterals}}</div>
            <div class="control">
                <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" [filterable]="false" [data]="scaleList"
                    [textField]="'value'" [valueField]="'id'" [value]="selectedScale"
                    (valueChange)="onScaleChange($event)"></kendo-dropdownlist>
            </div>
        </div>
        <div *ngIf="isPercent" class="row">
            <div class="row-title">{{'dashboard.multiply_by_100' | stringLiterals}}</div>
            <div class="control">
                <kendo-switch [checked]="multiplyBy100" onLabel="Yes" offLabel="No"
                    (valueChange)="onMultiplyBy100Change($event)"></kendo-switch>
            </div>
        </div>
        <div class="row">
            <div class="row-title">{{'dashboard.negatives' | stringLiterals}}</div>
            <div class="control">
                <tam-radio [value]="1" [(ngModel)]="config.settings.negatives" [disabled]="false"></tam-radio>
                <span>{{'dashboard.default' | stringLiterals}}</span>
            </div>
            <div class="control">
                <tam-radio [value]="2" [(ngModel)]="config.settings.negatives" [disabled]="false"></tam-radio>
                <span>{{'dashboard.abs_value' | stringLiterals}}</span>
            </div>
        </div>
        <div class="row">
            <div class="row-title">{{'dashboard.decimal_places' | stringLiterals}}</div>
            <div class="control">
                <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" [filterable]="false"
                    [data]="decimalPlacesList" [textField]="'value'" [valueField]="'id'" [value]="selectedDecimalPlaces"
                    (valueChange)="onDecimalPlacesChange($event)">
                </kendo-dropdownlist>
            </div>
        </div>
    </div>
    <div *ngIf="selectedProvider&&selectedProvider.type!==0" class="row">
        <div class="row-title">{{'dashboard.display_multiple_values' | stringLiterals}}</div>
        <kendo-switch [checked]="config.config.isMultipleMDL" onLabel="Yes" offLabel="No"
            (valueChange)="onMultipleMDLChange($event)"></kendo-switch>
    </div>
</div>